import { render, staticRenderFns } from "./RetailLabRegionForm.vue?vue&type=template&id=0b0c5116"
import script from "./RetailLabRegionForm.vue?vue&type=script&lang=js"
export * from "./RetailLabRegionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports